import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useStore from '../components/Hooks/useStore';

export default function RouterGuard({ children }: any) {
  const [, setters] = useStore();
  const {
    auth: { getProfile },
    user: { findUser },
  } = setters;
  const { pathname } = useLocation();

  const isPublicRoute = ['/', `/recover`].includes(pathname);

  const [auth, setAuth] = React.useState(isPublicRoute);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPublicRoute)
      getProfile()
        .then(() => {
          findUser().catch(() => {
            navigate('/');
          });
        })
        .catch(() => {
          navigate('/');
        })
        .finally(() => {
          setAuth(true);
        });
  }, []);

  return auth ? children : <></>;
}
